import { useState } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import moment from "moment";

import { fields } from "components/Charts/DeviceStats/fields";
import DeviceStatsChart from "components/Charts/DeviceStats/chart";

import ChartSelects from "components/Charts/Selectors/Stats";


// @mui material components
import Grid from "@mui/material/Grid";

function getGroupSize(start, end) {
  var gap = end - start;
  return (gap) / 40;
}

function DeviceStats({ title = "", height = "19.125rem", device }) {
  const [startTime, setStartTime] = useState(moment().subtract(2, "days"));
  const [endTime, setEndTime] = useState(moment());
  const [advancedToggle, setAdvancedToggle] = useState(false);
  const groupSize = getGroupSize(startTime.unix(), endTime.unix());

  return (
    <SoftBox>
      <ChartSelects {...{ startTime, setStartTime, endTime, setEndTime, advancedToggle, setAdvancedToggle }} />
        <Grid container spacing={1}>
          {Object.values(fields).map(function (field) {
            return (<Grid key={field.field} item xxs={12} lg={6} xl={6}>
              <DeviceStatsChart  {...{ device, "field": field, advancedToggle, startTime, setStartTime, endTime, setEndTime, groupSize, height }} />
            </Grid>);
          })}
        </Grid>
    </SoftBox>
  );

}

// Typechecking props for the DeviceStats
DeviceStats.propTypes = {
  title: PropTypes.string,
  device: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DeviceStats;

